export default "__VITE_ASSET__R44rQaew__"